import * as ApiTypes from "../../../../../api/types"

// tslint:disable:no-namespace
export namespace UiTypes {
  export type AttributeDataType =
    | "Text"
    | "Number"
    | "Decimal Number"
    | "Measure Number"
    | "Point"
    | "Curve"
    | "Surface"
    | "Solid"
    | "Annotation"
    | "MultiPoint"
    | "MultiCurve"
    | "MultiSurface"
    | "Dropdown Choice"
    | "Unknown"

  export type AttributeDataTypeOrGroup =
    | AttributeDataType
    | AttributeDataTypeGroup

  export interface AttributeDataTypeGroup {
    group: string
    types: AttributeDataTypeOrGroup[]
  }

  export const AttributeDataTypes: AttributeDataTypeOrGroup[] = [
    "Text",
    "Dropdown Choice",
    {
      group: "Number",
      types: ["Number", "Decimal Number", "Measure Number"],
    },
    {
      group: "Geometry",
      types: ["Point", "Curve", "Surface", "Solid", "Annotation", "MultiPoint", "MultiCurve", "MultiSurface"],
    },
  ]

  export interface CustomAttributeType
    extends Omit<ApiTypes.CustomAttributeType, "dataType"> {
    dataType: AttributeDataType
  }

  export interface AttributeTypeCreateRequest
    extends Omit<ApiTypes.AttributeTypeCreateRequest, "dataType"> {
    dataType: AttributeDataType
  }

  export const MeasureTypes = [
    "Coordinate",
    "Length",
    "MassWeight",
    "Time",
    "GpsTime",
    "Azimuth",
    "Pressure",
    "Volume",
    "Area",
    "Energy",
    "RoughnessIndex",
    "ElectricCurrent",
    "LuminousIntensity",
    "CelsiusTemperature",
    "ThermodynamicTemperature",
    "AmountOfSubstance",
    "AbsorbedDose",
    "DoseEquivalent",
    "ElectricCapacitance",
    "ElectricCharge",
    "ElectricConductance",
    "ElectricResistance",
    "ElectricVoltage",
    "Force",
    "Frequency",
    "Illuminance",
    "Inductance",
    "LuminousFlux",
    "MagneticFluxDensity",
    "MagneticFlux",
    "PlanAngle",
    "Power",
    "Radioactivity",
    "SolidAngle",
    "Acceleration",
    "AngularVelocity",
    "AreaDensity",
    "Curvature",
    "DynamicViscosity",
    "HeatFluxDensity",
    "HeatingValue",
    "IntegerCountRate",
    "IonConcentration",
    "IsotermalMoistureCapacity",
    "KinematicViscosity",
    "LinearForce",
    "LinearMoment",
    "LinearStiffness",
    "LinearVelocity",
    "MassDensity",
    "MassFlowRate",
    "MassPerLength",
    "ModulusOfElasticity",
    "ModulusOfLinearSubgradeReaction",
    "ModulusOfRotationalSubgradeReaction",
    "ModulusOfSubgradeReaction",
    "MoistureDiffusivity",
    "MolecularWeight",
    "Momentofinertia",
    "PH",
    "PlanarForce",
    "RotationalFrequency",
    "RotationalMass",
    "RotationalStiffness",
    "SectionalAreaIntegral",
    "SectionModulus",
    "ShearModulus",
    "SpecificHeatcapacity",
    "ThermalAdmittance",
    "ThermalConductivity",
    "ThermalResistance",
    "ThermalTransmittance",
    "Torque",
    "VaporPermeability",
    "VolumetricFlowrate",
    "WarpingMoment",
    "Ratio",
    "SoundPressureLevel",
    "CatalyticActivity",
    "Count",
    "ElectricConductivity",
    "RateOfPenetration",
    "Rating",
    "LugeonHydraulicConductivity",
    "CountPerLength",
    "CountPerVolume",
    "AmountOfMonetary",
    "AmountOfMonetaryPerUnit",
    "AmountOfMonetaryPerMass",
    "AmountOfMonetaryPerVolume",
    "AmountOfMonetaryPerArea",
    "AmountOfMonetaryPerLength",
  ]
}

export namespace UiToApi {
  function convertAttributeDataType(
    dataType: UiTypes.AttributeDataType
  ): ApiTypes.AttributeDataTypes {
    return dataType === "Decimal Number"
      ? ApiTypes.AttributeDataTypes.Real
      : dataType === "Measure Number"
      ? ApiTypes.AttributeDataTypes.Measure
      : dataType === "Number"
      ? ApiTypes.AttributeDataTypes.Integer
      : dataType === "Text" || dataType === "Dropdown Choice"
      ? ApiTypes.AttributeDataTypes.String
      : dataType === "Point"
      ? ApiTypes.AttributeDataTypes.Point
      : dataType === "Curve"
      ? ApiTypes.AttributeDataTypes.Curve
      : dataType === "Surface"
      ? ApiTypes.AttributeDataTypes.Surface
      : dataType === "Solid"
      ? ApiTypes.AttributeDataTypes.Solid
      : dataType === "Annotation"
      ? ApiTypes.AttributeDataTypes.Annotation
      : dataType === "MultiPoint"
      ? ApiTypes.AttributeDataTypes.MultiPoint
      : dataType === "MultiCurve"
      ? ApiTypes.AttributeDataTypes.MultiCurve
      : dataType === "MultiSurface"
      ? ApiTypes.AttributeDataTypes.MultiSurface
      : ApiTypes.AttributeDataTypes.Unknown
  }

  export function convertAttributeType(
    at: UiTypes.CustomAttributeType
  ): ApiTypes.CustomAttributeType {
    return {
      ...at,
      dataType: convertAttributeDataType(at.dataType),
    }
  }

  export function convertAttributeTypeCreateRequest(
    at: UiTypes.AttributeTypeCreateRequest
  ): ApiTypes.AttributeTypeCreateRequest {
    return {
      ...at,
      dataType: convertAttributeDataType(at.dataType),
    }
  }
}

export namespace ApiToUi {
  function getAttributeDataType(
    at: ApiTypes.CustomAttributeType
  ): UiTypes.AttributeDataType {
    return at.dataType === ApiTypes.AttributeDataTypes.Real
      ? "Decimal Number"
      : at.dataType === ApiTypes.AttributeDataTypes.Measure
      ? "Measure Number"
      : at.dataType === ApiTypes.AttributeDataTypes.Integer
      ? "Number"
      : at.dataType === ApiTypes.AttributeDataTypes.Point
      ? "Point" 
      : at.dataType === ApiTypes.AttributeDataTypes.Curve
      ? "Curve" 
      : at.dataType === ApiTypes.AttributeDataTypes.Surface
      ? "Surface" 
      : at.dataType === ApiTypes.AttributeDataTypes.Solid
      ? "Solid" 
      : at.dataType === ApiTypes.AttributeDataTypes.Annotation 
      ? "Annotation" 
      : at.dataType === ApiTypes.AttributeDataTypes.MultiPoint
      ? "MultiPoint"
      : at.dataType === ApiTypes.AttributeDataTypes.MultiCurve
      ? "MultiCurve" 
      : at.dataType === ApiTypes.AttributeDataTypes.MultiSurface
      ? "MultiSurface" 
      : at.dataType === ApiTypes.AttributeDataTypes.String
      ? at.hasLegalValues
        ? "Dropdown Choice"
        : "Text"
      : "Unknown"
  }

  export function convertAttributeType(
    at: ApiTypes.CustomAttributeType
  ): UiTypes.CustomAttributeType {
    return {
      ...at,
      dataType: getAttributeDataType(at),
    }
  }

  export const convertMeasureType = (dataType?: ApiTypes.MeasureTypes): string => dataType || "Length"
}
